import React from 'react'

import { NavLink as RouterNavLink, NavLinkProps, useParams } from 'react-router-dom'

import { useQueryPaginator } from 'src/components/Table'
import { DockDetailTable } from 'src/components/Table/detail/Dock'
import { EventListTable } from 'src/components/Table/list/Event'
import { DockDialog } from 'src/modules/supply_chain/components/DockDialog'
import { urlFor } from 'src/routes'

import { skuit } from 'src/services/skuit'
import { useQuery } from 'react-query'

import { DetailPage } from 'src/components/Pages/DetailPage'
import { DetailTab } from 'src/components/Pages/Tab'

const NavLink = React.forwardRef((props: NavLinkProps, ref: React.Ref<HTMLAnchorElement>) => (
  <RouterNavLink innerRef={ref} {...props} />
))
NavLink.displayName = 'NavLink'

interface PathProps {
  guid: string
}

const DetailsTab = () => {
  return (
    <DetailTab>
    </DetailTab>
  )
}

const EventsTab = () => {
  const { guid } = useParams<PathProps>()

  const eventsPaginator = useQueryPaginator('event-list', skuit.sc.events.list, {
    params: { page_size: 5, references: guid },
  })

  return (
    <DetailTab>
      <EventListTable
        paginator={eventsPaginator}
        title="Dock Events"
        fields={['type', 'data', 'by', 'on']}
      />
    </DetailTab>
  )
}

export const DockPage = () => {
  const { guid } = useParams()

  const dock = useQuery(['dock-details', guid], () => skuit.sc.docks.retrieve(guid))

  const refresh = () => {
    dock.refetch()
  }

  return (
    <>
      <DetailPage
        obj={dock}
        title="Dock Door"
        refresh={refresh}
        breadcrumbs={[
          { title: 'Dashboard', url: '/' },
          { title: 'Facilities', url: '/warehouse/facilities' },
          { title: dock.data?.facility?.name || '', url: urlFor(dock.data?.facility) || '' },
        ]}
        detailComponent={<DockDetailTable obj={dock} refresh={refresh} />}
        createDialog={{ title: 'New Dock', Dialog: DockDialog }}
        tabs={['Details', 'Events']}
      >
       <DetailsTab />
       <EventsTab />
      </DetailPage>
    </>
  )
}
